angular.module('registerAppComponents', [])
    .component('root', {
        $routeConfig: [
            { path: '/user', name: 'UserForm', component: 'user', useAsDefault: true },
            { path: '/chain', name: 'ChainForm', component: 'chain' },
            { path: '/branch', name: 'BranchForm', component: 'branch' },
            { path: '/positions', name: 'PositionsForm', component: 'positions' },
            { path: '/module', name: 'ModuleForm', component: 'module' },
            { path: '/summary', name: 'Summary', component: 'summary' }
        ],
        template: '<ng-outlet></ng-outlet>'
    })
    .component('user', {
        controller: ['regDataService', '$http', '$rootRouter', '$window', '$rootScope', 'showPopupService',
            function(regDataService, $http, $rootRouter, $window, $rootScope, showPopupService
        ) {
            var $ctrl                    = this;
            $ctrl.loaderIsVisible        = false;
            $ctrl.regData                = regDataService.regData;
            $ctrl.regData.module         = 'BOSS'
            $ctrl.step                   = 1;

            $ctrl.$routerOnActivate = function(){
                showPopupService.obj = $ctrl.regData.user;
                showPopupService.getPopup();
            };

            $ctrl.save = function(form) {
                $ctrl.loaderIsVisible        = true;
                $http.post('/validate-user', $ctrl.regData.user).success(function(response) {
                    if(response.status == false && response.errors != null) {
                        angular.forEach(response.errors, function(fieldErrors, fieldName) {
                            angular.forEach(fieldErrors, function(error) {
                                form[fieldName].$setValidity(error, false);
                            });
                        });
                    } else{
                        $ctrl.regData.branch.phone = $ctrl.regData.user.phone;
                        $rootRouter.navigate(['ChainForm']);
                    }
                    $ctrl.loaderIsVisible = false;
                });
            };
        }],
        templateUrl: '/partials/user'
    })
    .component('chain', {
        bindings: {
            countryName: '<'
        },
        controller: ['regDataService', '$http', '$rootRouter', 'geoService', 'localeService',
            'showPopupService', 'timezoneService', 'businessService',  function(
            regDataService, $http, $rootRouter, geoService, localeService,
            showPopupService, timezoneService, businessService
        ) {
            var $ctrl             = this;
            $ctrl.timezones       = timezoneService.timezones;
            $ctrl.regionId        = '';
            $ctrl.cityId          = '';
            $ctrl.businessTypes   = [];

            if ($ctrl.timezones.length == 0) {
                timezoneService.loadTimezones().then(function(data) {
                    $ctrl.timezones = data;
                });
            }

            $ctrl.addressError = '';
            $ctrl.loaderIsVisible = false;
            $ctrl.step            = 2;

            $ctrl.regData                     = regDataService.regData;
            $ctrl.regData.chain.self_register = 1;
            $ctrl.locales = localeService.locales;

            if ( typeof $ctrl.regData.chain.default_locale == "undefined" || $ctrl.regData.chain.default_locale == '') {
                $ctrl.regData.chain.default_locale = $ctrl.locales[0].code;
            }

            $ctrl.setAddress = function(){

                if ( typeof $ctrl.regData.chain.address != "undefined" ) {
                      return true;
                }

                $ctrl.regData.chain.address = {
                    name: '',
                    place: '',
                    components: {
                        placeId: '',
                        streetNumber: '',
                        street: '',
                        city: '',
                        state: '',
                        countryCode: '',
                        country: '',
                        postCode: '',
                        district: '',
                        location: {
                            lat: '',
                            long: ''
                        }
                    }
                };
            }

            $ctrl.setAddress();

            $ctrl.countries = geoService.countries;

            if ($ctrl.countries.length == 0) {
                geoService.loadCountries().then(function(data) {
                    $ctrl.countries = data;
                });
            }

            $ctrl.$routerOnActivate = function(){
                showPopupService.obj = $ctrl.regData.chain;
                businessService.loadBusinessTypes().then(function(data){
                    $ctrl.businessTypes = data;
                })
            };

            /**
             *
             */
            $ctrl.setInformation = function(form){

                showPopupService.ignorePopup = true;
                $http.post('/validate-chain', $ctrl.regData.chain).success(function(response) {
                    if(response.status == false && response.errors != null) {
                        angular.forEach(response.errors, function(fieldErrors, fieldName) {
                            angular.forEach(fieldErrors, function(error) {
                                form[fieldName].$setValidity(error, false);
                            });
                        });
                    } else{
                        $rootRouter.navigate(['PositionsForm']);
                    }
                    $ctrl.loaderIsVisible = false;
                });
            };

            /**
             *
             * @returns {boolean}
             */
            $ctrl.validation = function(){
                $ctrl.addressError = '';

                if ( $.trim($ctrl.regData.chain.address.components.countryCode) == '') {
                    $ctrl.addressError = 'Country can not be empty';
                    return false;
                }

                if ($.trim($ctrl.regData.chain.address.components.state) == '') {
                    $ctrl.addressError = 'Region can not be empty';
                    return false;
                }

                if ($.trim($ctrl.regData.chain.address.components.city) == '') {
                    $ctrl.addressError = 'City can not be empty';
                    return false;
                }

                if ($.trim($ctrl.regData.chain.address.components.street) == '') {
                    $ctrl.addressError = 'Street can not be empty';
                    return false;
                }
            };

            /**
             *
             * @param form
             */
            $ctrl.getRegions = function(form){
                geoService.loadRegions($ctrl.countryCode).then(function(data){
                    angular.forEach(data, function(region){

                        if ( $ctrl.regData.chain.address.components.countryCode == region.countryCode
                            && region.name ==  $ctrl.regData.chain.address.components.state
                        ) {
                            $ctrl.regData.branch.regionId = parseInt(region.id);
                            $ctrl.regionId                = parseInt(region.id);
                            $ctrl.getCities(form);
                        }
                    });

                    if ($.trim($ctrl.regionId) == '' ) {
                        geoService.setRegion($ctrl.regData.chain.address.components.countryCode,
                                $ctrl.regData.chain.address.components.state
                            )
                            .then(function(data) {
                                if ( typeof data != "undefined" && data && typeof data.id != "undefined" ) {
                                    $ctrl.regData.branch.regionId = parseInt(data.id);
                                    $ctrl.regionId = parseInt(data.id);
                                    geoService.loadRegions($ctrl.regData.branch.regionId).then(function(data) {
                                        $ctrl.regions = data;
                                    });

                                    $ctrl.getCities(form);
                                } else {
                                    alert('Region cannot be created: Something went wrong')
                                }
                        });
                    }
                });
            };

            /**
             *
             */
            $ctrl.getCountries = function(form){
                geoService.loadCountries().then(function(data){
                    angular.forEach(data, function(country){
                        if ( country.code == $ctrl.regData.chain.address.components.countryCode ) {
                            $ctrl.regData.chain.country_code = $ctrl.regData.chain.address.components.countryCode;
                            $ctrl.regData.branch.countryCode = $ctrl.regData.chain.country_code;

                        }
                    });

                    if ( typeof $ctrl.regData.chain.country_code == "undefined" ) {
                        $ctrl.addressError = 'This country does not exist in the Countries List';
                        $ctrl.countryCode  = '';
                        $ctrl.countryName  = '';
                    } else {
                        $ctrl.getRegions(form);
                    }
                });
            };

            /**
             *
             * @param form
             */
            $ctrl.getCities = function(form){
                geoService.loadCities($ctrl.regionId).then(function(data){
                    angular.forEach(data, function(city){
                        if ( $ctrl.regData.chain.address.components.city == city.name
                            && city.regionId    ==  $ctrl.regionId
                            && city.countryCode ==  $ctrl.regData.chain.address.components.countryCode
                        ) {
                            $ctrl.regData.branch.cityId = parseInt(city.id);
                            $ctrl.cityId                = parseInt(city.id);
                            $ctrl.setTimeZone(
                                $ctrl.regData.chain.address.components.location.lat,
                                $ctrl.regData.chain.address.components.location.long,
                                form
                            );
                        }
                    });

                    if ( $.trim($ctrl.cityId) == '' ) {
                        geoService.setCity($ctrl.regData.chain.address.components.countryCode,
                                $ctrl.regionId, $ctrl.regData.chain.address.components.city
                            ).then(function(data) {
                            $ctrl.regData.branch.cityId = parseInt(data.id);
                            $ctrl.cityId                = parseInt(data.id);
                            geoService.loadCities($ctrl.regionId).then(function(data) {
                                $ctrl.cities = data;
                            });


                            $ctrl.setTimeZone(
                                $ctrl.regData.chain.address.components.location.lat,
                                $ctrl.regData.chain.address.components.location.long,
                                form
                            );

                        });
                    }
                });
            };


            $ctrl.setTimeZone = function(lat, long, form){
                geoService.getTimeZone(lat, long).then(function(data){

                    if ( typeof data != "undefined" && typeof data.timeZoneId != "undefined" ) {

                        var timeZoneName = timezoneService.getTimezoneNameByCode(data.timeZoneId);

                        if ( typeof timeZoneName != "undefined" && typeof timeZoneName != null && timeZoneName ) {
                            $ctrl.regData.branch.timeZone = data.timeZoneId;
                            $ctrl.setInformation(form );
                        } else {
                            $ctrl.addressError = data.timeZoneId +
                                ': This Time Zone does not exist in the system.'
                                +' Please, ask administrator to add this time zone.';
                            $ctrl.regionId = '';
                            $ctrl.cityId   = '';
                        }
                    } else {
                        $ctrl.regionId     = '';
                        $ctrl.cityId       = '';
                        $ctrl.addressError =  'Google can not define a time zone';
                    }
                });
            }

            /**
             *
             * @param form
             */
            $ctrl.save = function(form) {

                $ctrl.validation();
                if ( $ctrl.addressError != '' ) {
                    return false;
                }

                $ctrl.loaderIsVisible       = true;
                $ctrl.regData.branch.street = $ctrl.regData.chain.address.components.street;
                $ctrl.regData.branch.zip    = $ctrl.regData.chain.address.components.postCode;
                $ctrl.regData.branch.name   = $ctrl.regData.chain.name;
                $ctrl.getCountries(form);
            };
        }],
        templateUrl: '/partials/chain'
    })
    .component('positions', {
        controller: ['regDataService', 'positionsService', 'showPopupService', '$rootRouter', function(
            regDataService, positionsService, showPopupService, $rootRouter
        ) {
            var $ctrl                 = this;
            $ctrl.regData             = regDataService.regData;
            $ctrl.available_positions = positionsService.positions;
            $ctrl.step                = 4;

            $ctrl.selectedPositions   = [];

            $ctrl.$routerOnActivate = function(){
                showPopupService.obj  = $ctrl.regData.positions;

                if ( typeof $ctrl.regData.user.user_template_position_id != "undefined"
                     || $.trim($ctrl.regData.user.user_template_position_id) != ''
                ) {
                    $ctrl.selectedPositions   = [];
                    angular.forEach($ctrl.regData.positions, function(positionId, k) {
                        angular.forEach($ctrl.available_positions, function(posObj, k1) {

                            if ( typeof posObj != "undefined" && parseInt(positionId) == parseInt(posObj['id'])){
                                $ctrl.selectedPositions.push(posObj)
                            }
                        });
                    });
                }
            };

            positionsService.loadPositions($ctrl.regData.chain.default_locale).then(function(data) {
                $ctrl.available_positions = data;
            });

            $ctrl.toggleSelection = function(positionId, positionObj) {
                var idx = $ctrl.regData.positions.indexOf(positionId);

                // is currently selected
                if (idx > -1) {
                    $ctrl.regData.positions.splice(idx, 1);

                    angular.forEach($ctrl.selectedPositions, function(objPosition, key) {
                        if ( objPosition['id'] != "undefined" && parseInt(objPosition['id']) == parseInt(positionId) ){
                            $ctrl.selectedPositions.splice(key, 1);
                        }
                    });

                    if ( parseInt($ctrl.regData.user.user_template_position_id) == parseInt(positionId)) {
                        $ctrl.regData.user.user_template_position_id = '';
                    }
                }

                // is newly selected
                else {
                    $ctrl.regData.positions.push(positionId);
                    $ctrl.selectedPositions.push(positionObj);
                }
            };

            $ctrl.getPositionName = function(){
                if ( typeof $ctrl.regData.user != "undefined"
                    && $ctrl.regData.user.user_template_position_id
                    && $.trim($ctrl.regData.user.user_template_position_id) != ''
                    && $ctrl.available_positions
                    ) {
                    angular.forEach($ctrl.available_positions, function(objPosition, key) {

                        if ( objPosition
                            && typeof objPosition['id'] != "undefined"
                            && parseInt(objPosition['id']) == parseInt($ctrl.regData.user.user_template_position_id)
                            ){
                            $ctrl.regData.user.positionsNameToDisplay = objPosition['name']
                        }
                    });
                }
            };

            $ctrl.next = function(){
                $ctrl.getPositionName();
                $rootRouter.navigate(['Summary']);
            }
        }],
        templateUrl: '/partials/positions'
    })
    .component('summary', {
        controller: ['regDataService', 'geoService', 'timezoneService',
            'positionsService', 'localeService', 'showPopupService', 'sendEmail', 'checkCode', '$window',
            function(regDataService, geoService, timezoneService,
             positionsService, localeService, showPopupService, sendEmail, checkCode, $window) {
            var $ctrl   = this;
            $ctrl.step  = 6;
            $ctrl.showSubmitIndicator = false;
            $ctrl.sendCodeButtonText  = '<i class="arrow-icon glyphicon glyphicon-envelope"></i>&nbsp;&nbsp;'+'Send email';

            $ctrl.submitStatus          = false;
            $ctrl.submitIsDisabled      = false;
            $ctrl.loaderIsVisible       = false;
            $ctrl.successBlockIsVisible = false;
            $ctrl.loginUrl              = null;

            $ctrl.emailCode             = '';
            $ctrl.emailCodeError        = '';

            $ctrl.regData = regDataService.regData;
            $ctrl.errors  = [];

            $ctrl.emailSending = false;

            $ctrl.positions = positionsService.getPositionNamesByIds($ctrl.regData.positions);
            $ctrl.chainCountryName = geoService.getCountryNameByCode($ctrl.regData.chain.country_code);
            $ctrl.chainLocaleName = localeService.getLocaleNameByCode($ctrl.regData.chain.default_locale);
            $ctrl.branchCountryName = geoService.getCountryNameByCode($ctrl.regData.branch.countryCode);
            $ctrl.branchRegionName = geoService.getRegionNameById($ctrl.regData.branch.regionId);
            $ctrl.branchCityName = geoService.getCityNameById($ctrl.regData.branch.cityId);
            $ctrl.branchTimezone = timezoneService.getTimezoneNameByCode($ctrl.regData.branch.timeZone);

            /**
             *
             */
            $ctrl.sendMail = function(showMessage){

                $ctrl.emailSending = true;

                var displayAlert =  ( typeof showMessage == "undefined" )? true : showMessage;
                sendEmail.sendEmail($ctrl.regData.user).then(function(data){
                    if ( !data && data.status != true )  {
                        var message = (data && data.message && $.trim(data.message) != '' )?
                            $.trim(data.message): 'something went wrong';
                        alert('Server Error: ' + message);
                    }

                    $ctrl.emailSending = false;
                    $ctrl.sendCodeButtonText  = '<i class="arrow-icon glyphicon glyphicon-envelope"></i>&nbsp;&nbsp;'
                        +'Resend email';
                });
            };

            /**
             *
             */
            $ctrl.checkCode = function(){
                var email             = (typeof $ctrl.regData != "undefined"
                    && typeof $ctrl.regData.user == "object"
                    && $ctrl.regData.user.email)? $ctrl.regData.user.email : '';
                $ctrl.emailCodeError  = '';

                if ($.trim(email) == '' || $.trim($ctrl.emailCode) == '' ) {
                    return;
                }

                checkCode.checkCode(email, $ctrl.emailCode).then(function(data){

                    if ( typeof data == "undefined" || !data || typeof data.status == "undefined" ) {
                        alert('Server Error: ' + 'something went wrong');
                    }
                    if ( data.status == true ) {
                        $ctrl.showSubmitIndicator = true;
                    } else  if (data.message && $.trim(data.message) != '' ) {
                        $ctrl.emailCodeError = $.trim(data.message);
                    }
                });
            };

            $ctrl.submit = function() {

                $ctrl.loaderIsVisible = true;
                $ctrl.submitIsDisabled = true;
                $ctrl.successBlockIsVisible = false;
                regDataService.submit().then(function(data) {
                    $ctrl.loaderIsVisible = false;
                    $ctrl.submitIsDisabled = false;

                    if(typeof data != "undefined" && data.status && data.login_url) {
                        $ctrl.errors = [];
                      //  $ctrl.successBlockIsVisible = true;
                        $ctrl.loginUrl = data.login_url;
                        $ctrl.submitStatus = true;

                        showPopupService.submitted = ($ctrl.submitStatus == true && $ctrl.loginUrl)? true : false;
                        $window.location.href = data.login_url;

                    } else {
                        $ctrl.submitStatus = false;
                        $ctrl.errors = data.errors || [];
                    }
                }, function() {
                    $ctrl.loaderIsVisible = false;
                });
            };
        }],
        templateUrl: '/partials/summary'
    });